var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScheduleTraining(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1709_729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.71893 8.05429H2.3042V9.46972H3.71893V8.05429Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.71893 10.2922H2.3042V11.7063H3.71893V10.2922Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.09003 5.81503H4.67529V7.22977H6.09003V5.81503Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.09003 8.05429H4.67529V9.46972H6.09003V8.05429Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.09003 10.2922H4.67529V11.7063H6.09003V10.2922Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1692 6.0186V1.89122C13.1692 1.34335 12.7217 0.895905 12.1739 0.895905H0.995315C0.447447 0.895905 0 1.34335 0 1.89122V13.0691C0 13.617 0.447447 14.0644 0.995315 14.0644H8.29172C9.10326 14.7141 10.1314 15.1041 11.2517 15.1041C13.8735 15.1041 16 12.9796 16 10.3578C15.9993 8.41978 14.8346 6.75569 13.1692 6.0186ZM4.31388 1.87345H8.85114V3.04637H4.31388V1.87345ZM1.22279 4.16668H11.945V5.66819C11.7182 5.63471 11.4873 5.6115 11.251 5.6115C10.2065 5.6115 9.24396 5.95304 8.45975 6.52482V5.81437H7.04568V7.2291H7.68849C6.95413 8.06455 6.50601 9.15754 6.50601 10.3578C6.50601 11.2144 6.73621 12.0157 7.13242 12.7091H1.22279V4.16668ZM10.8158 6.49132C10.8158 6.25019 11.0119 6.05686 11.251 6.05686C11.4928 6.05686 11.6861 6.25019 11.6868 6.49132C11.6868 6.73178 11.4928 6.92648 11.251 6.92648C11.0126 6.92648 10.8158 6.73178 10.8158 6.49132ZM7.82033 10.3585C7.82033 10.5996 7.62633 10.795 7.3845 10.795C7.14338 10.795 6.94934 10.5996 6.94934 10.3585C6.94934 10.1173 7.14335 9.92401 7.3845 9.92401C7.62566 9.92401 7.81966 10.1173 7.82033 10.3585ZM11.251 14.6607C11.0119 14.6607 10.8158 14.4667 10.8158 14.227C10.8158 13.9851 11.0119 13.7898 11.251 13.7898C11.4928 13.7898 11.6861 13.9845 11.6868 14.227C11.6868 14.4661 11.4928 14.6607 11.251 14.6607ZM13.8864 8.39587L12.0646 10.215C12.0769 10.271 12.0987 10.3229 12.0987 10.3824C12.0987 10.8544 11.7155 11.2377 11.2435 11.2377C10.7878 11.2377 10.423 10.8777 10.3984 10.4268L8.46317 8.92325C8.2958 8.79208 8.25618 8.56121 8.37779 8.40683C8.4987 8.25039 8.73368 8.23126 8.90105 8.36243L10.6723 9.74094C10.8254 9.59748 11.0276 9.50595 11.2523 9.50595C11.4012 9.50595 11.5338 9.55377 11.6554 9.62072L13.3816 7.89244C13.5428 7.73191 13.7867 7.7162 13.9233 7.85488C14.0606 7.99283 14.0449 8.23465 13.8864 8.39587ZM15.1174 10.7943C14.8769 10.7943 14.6822 10.5989 14.6822 10.3578C14.6822 10.1166 14.8769 9.92332 15.1174 9.92332C15.3586 9.92332 15.5539 10.1167 15.5539 10.3578C15.5539 10.5989 15.3592 10.7943 15.1174 10.7943Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1709_729"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleTraining);
export default __webpack_public_path__ + "static/media/schedule_training.5c5bdaefb5778c3654b6157174fa17e9.svg";
export { ForwardRef as ReactComponent };